import { persianDateFormat, handleTypesName } from "./function.helper";

export const columns = (lang: string, warehouseList: any) => {
  return [
    {
      title: lang === "en-US" ? "Number" : "شماره ردیف",
      dataIndex: "number",
      key: "number",
    },
    {
      title: lang === "en-US" ? "Entry & Exit" : " ورود/خروج",
      dataIndex: "entryAndExit",
      key: "entryAndExit",
      render: (source: number) => (
        <>{source === 100 ? "ورود" : source === 200 ? "خروج" : 0}</>
      ),
    },

    {
      title: lang === "en-US" ? "quantity" : "تعداد",
      dataIndex: "quantity",
      key: "name",
    },
    {
      title: lang === "en-US" ? "Type" : "نوع",
      dataIndex: "type",
      key: "type",
    },
    {
      title: lang === "en-US" ? "Name" : "نام محصول",
      dataIndex: "productName",
      key: "productName",
      sorter: false,
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      sorter: false,
    },
    {
      title: lang === "en-US" ? "Warehouse" : "نام انبار",
      dataIndex: "warehouseId",
      key: "warehouseId",
      sorter: false,
      render: (source: number) => (
        <>
          {warehouseList.find((warehouse: any) => warehouse.id === source)
            ? warehouseList.find((warehouse: any) => warehouse.id === source)
                .name
            : "--"}
        </>
      ),
    },
    {
      title: lang === "en-US" ? "CreationTime" : "تاریخ ایجاد",
      dataIndex: "creationTime",
      key: "creationTime",
      sorter: true,
    },
  ];
};
export const datahelper = (res: any, page: number) => {
  const newData = res.map((item: any, index: number) => {
    return {
      ...item,
      key: item.id,
      creationTime: persianDateFormat(item.creationTime),
      actions: item.id,
      warehouseId: item.warehouseId,
      number: index + 1 + 40 * (page - 1),
      type: handleTypesName(item.type),
    };
  });
  return newData;
};
